import React, { useEffect, useState } from 'react'
import ReactCompareImage from '../ReactCompareImage'
import useWindowSize from '../../hooks/useWindowSize'
import { install } from 'resize-observer'

import {
  imageComparisonSliderContainer,
  imageComparisonHeader,
  imageComparisonWrapper,
} from './index.module.css'

const ImageComparisonSlider = ({
  title,
  subtitle,
  backgroundColor,
  components,
}) => {
  const size = useWindowSize()
  const [isMobile, setMobile] = useState(false)

  useEffect(() => {
    setMobile(size.width <= 834)
  }, [size.width])

  if (typeof window !== 'undefined') {
    if (!window.ResizeObserver) {
      install()
    }
  }

  return (
    <div className={imageComparisonSliderContainer} style={{ backgroundColor }}>
      <div className={imageComparisonHeader}>
        <h2>{title}</h2>
        {subtitle && (
          <div
            className="paragraph"
            dangerouslySetInnerHTML={{
              __html: subtitle.childMarkdownRemark.html,
            }}
          />
        )}
      </div>
      <div className={imageComparisonWrapper}>
        <ReactCompareImage
          aspectRatio="wider"
          leftImage={components[0].image.file.url}
          leftImageLabel={components[0].subtitle.subtitle}
          leftImageLabelColor={isMobile ? `#fff` : components[0].color}
          rightImage={components[1].image.file.url}
          rightImageLabel={components[1].subtitle.subtitle}
          rightImageLabelColor={isMobile ? `#fff` : components[1].color}
          sliderLineColor="#5E79FB"
        />
      </div>
    </div>
  )
}

export default ImageComparisonSlider
